import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE = `${config.API_URL}KPIDashboardLockdown`;

// ── Lockdowns ──────────────────────────────────────────────────────────────
export const searchLockdowns = ({ search, page = 1, pageSize = 100 }) =>
	AxiosRequest({ method: 'GET', url: BASE, params: { search, page, pageSize } });

export const getLockdownDetail = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${id}` });

// Returns raw combination rows for frontend cascade filtering.
// Called ONCE per tech when selected (no filters applied).
export const getFilterMatrix = (id, tech, dateFrom, dateTo) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${id}/filter-matrix`, params: { tech, dateFrom, dateTo } });

// ── KPI Config (kpi_config_lockdown table) ─────────────────────────────────
export const getKpiConfig = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/kpi-config` });

export const getKpiConfigByTech = (tech) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/kpi-config/${tech}` });

// ── KPI Data ───────────────────────────────────────────────────────────────
export const getKpiBatch = (charts) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/batch`, data: { charts } });